export default [
    {
        date: 1516451323091,
        row: 4,
        col: 4,
        squares: [
            [1, 1, "#00FF00"],
            [1, 2, "#00FF00"],
            [1, 3, "#00FF00"],
            [1, 4, "#00FF00"],
            [2, 4, "#00FF00"],
            [3, 4, "#00FF00"],
            [4, 4, "#00FF00"],
            [4, 3, "#00FF00"],
            [4, 2, "#00FF00"],
            [4, 1, "#00FF00"],
            [3, 1, "#00FF00"],
            [2, 1, "#00FF00"],
            [2, 2, "#FF00FF"],
            [2, 3, "#FF00FF"],
            [3, 3, "#FF00FF"],
            [3, 2, "#FF00FF"],
        ],
    },
    {
        date: 1445438181081,
        row: 4,
        col: 4,
        squares: [
            [1, 1, "#000080"],
            [2, 2, "#000080"],
            [4, 4, "#000080"],
            [3, 3, "#000080"],
            [1, 2, "#00FF00"],
            [2, 3, "#00FF00"],
            [3, 4, "#00FF00"],
            [2, 1, "#00FF00"],
            [4, 3, "#00FF00"],
            [3, 2, "#00FF00"],
            [1, 3, "#FFFF00"],
            [2, 4, "#FFFF00"],
            [3, 1, "#FFFF00"],
            [4, 2, "#FFFF00"],
            [4, 1, "#FF0000"],
            [1, 4, "#FF0000"],
        ],
    },
    {
        date: 1445438181081,
        row: 4,
        col: 4,
        squares: [
            [1, 1, "#F2DCB3"],
            [2, 1, "#F2DCB3"],
            [2, 3, "#F2DCB3"],
            [3, 3, "#F2DCB3"],
            [4, 3, "#F2DCB3"],
            [4, 4, "#F2DCB3"],
            [4, 1, "#1A3540"],
            [4, 2, "#1A3540"],
            [3, 2, "#1A3540"],
            [2, 2, "#1A3540"],
            [2, 4, "#1A3540"],
            [1, 4, "#1A3540"],
        ],
    },
    {
        date: 1445438181081,
        row: 4,
        col: 4,
        squares: [
            [1, 1, "#FF0000"],
            [2, 2, "#FF0000"],
            [3, 3, "#FF0000"],
            [4, 4, "#FF0000"],
            [1, 4, "#FFFF00"],
            [2, 3, "#FFFF00"],
            [3, 2, "#FFFF00"],
            [4, 1, "#FFFF00"],
        ],
    },
    {
        date: 1445438181081,
        row: 4,
        col: 4,
        squares: [
            [1, 1, "#000000"],
            [2, 2, "#000000"],
            [3, 3, "#000000"],
            [4, 4, "#000000"],
            [1, 4, "#000000"],
            [2, 3, "#000000"],
            [3, 2, "#000000"],
            [4, 1, "#000000"],
        ],
    },
    {
        date: 1445438181081,
        row: 4,
        col: 4,
        squares: [
            [1, 1, "#000000"],
            [1, 2, "#000000"],
            [1, 3, "#000000"],
            [1, 4, "#000000"],
            [4, 2, "#000000"],
            [4, 3, "#000000"],
            [4, 4, "#000000"],
            [4, 1, "#000000"],
        ],
    },
    {
        date: 1445438181081,
        row: 4,
        col: 4,
        squares: [
            [2, 1, "#00FFFF"],
            [2, 2, "#00FFFF"],
            [2, 3, "#00FFFF"],
            [2, 4, "#00FFFF"],
            [1, 2, "#00FF00"],
            [1, 3, "#00FF00"],
            [3, 2, "#00FF00"],
            [3, 3, "#00FF00"],
            [4, 1, "#00FF00"],
            [4, 2, "#00FF00"],
            [4, 3, "#00FF00"],
            [4, 4, "#00FF00"],
        ],
    },
];
